import { createAction } from 'redux-actions';

import * as actionTypes from '../actionTypes/readers';

export const doReadDeviceUpdateList = createAction(actionTypes.DEVICE_UPDATE_LIST);
